import type { IApiResponse } from '@/interfaces/IApiResponse'
import type { CreateCustomerVerification, CustomerVerification } from '@/interfaces/ICustomerVerification'
import type { ToggleDisplayChannelResponse } from '@/interfaces/ToggleDisplayChannelResponse'
import useAxios from '@/composable/useAxios'

export const customerVerificationApi = {
    get: async (type: string): Promise<CustomerVerification> => {
        const { data: response } = await useAxios.get<IApiResponse<CustomerVerification>>(
            `/v1/me/verification/type/${type}`,
        )
        return response.data
    },
    post: async (request: CreateCustomerVerification): Promise<void> => {
        await useAxios.post(`/v1/me/verification`, {
            Type: request.type,
            Value: request.value,
        })
    },
}

export const userInfoApi = {
    toggleDisplayChannel: async (): Promise<boolean> => {
        const { data: response } = await useAxios.get<IApiResponse<ToggleDisplayChannelResponse>>(
            '/v1/channels/availability',
        )
        return response.data.isDisplayChannel
    },
}
